import { render, staticRenderFns } from "./RewardList.vue?vue&type=template&id=9fb480e6&scoped=true&"
import script from "./RewardList.vue?vue&type=script&lang=js&"
export * from "./RewardList.vue?vue&type=script&lang=js&"
import style0 from "./RewardList.vue?vue&type=style&index=0&id=9fb480e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fb480e6",
  null
  
)

export default component.exports